import React, {useEffect, useState} from 'react';
import { useAppSelector } from "../DAL/store";
import SbsCheckIcon from "../icons/sbs-check";
import CloseIcon from "../../../ui/svg/common/close";
import {PluginsPopup} from "../components/plugins-popup/plugins-popup";
import TwoMonthFreePopup from '../components/two-month-free/two-month-free-popup';
import {SubscriptionSlider} from "../components/subscription-slider";
import {MainBannerPriceDifferent} from "../components/main-banner-price-different";
import {PlansPricingDesignNew} from "../components/plans-pricing-design-new";
import {MainBannerWCATopNew} from "../components/main-banner-wcatop-new";
import { GetQueryWithNoParams } from '../services/logic-helper';
import { getQueryString } from '../../../domain/url-provider';

/**
 * the entry point
 */
const App: React.FC = () => {

    const ImageCDNDomain = (document.getElementById('img-cdn-domain')?.textContent || '')?.trim().toLowerCase();
    const [showPluginsPopup, setShowPluginsPopup] = useState(false);
    /**
     * softwareCodesAlertValue === -1 hide alert
     *
     */
    const [sbsAlertValue, setSbsAlertValue] = useState("");


    const SbsActiveTiers = useAppSelector((store) => store.SbsActiveTiers);
    const IsPriceDifferent = useAppSelector((store) => store.IsPriceDifferent);
    const QueryStringsReponse = useAppSelector((store) => store.QueryStringsReponse);
    const IsTwoMonthFreePopupShown = useAppSelector((store) => store.IsTwoMonthFreePopupShown);

    useEffect(() => {

        if(SbsActiveTiers.length === 0){
            return;
        }else{
            // Old proplematic version
            // It removes hashes event whn not needed
            // ========================================

            //remove URL param: plugins & skus on page load
            let queryString = GetQueryWithNoParams(["plugins","skus"]);

            const urlLink = getQueryString()['scroll'];
            if(urlLink !== undefined && urlLink !== null && urlLink !== '')
                document.getElementById(urlLink)?.scrollIntoView();

            if(queryString.length > 0){
                queryString = "?" + queryString;
            }
            window.history.replaceState({}, '', window.location.protocol + '//' + window.location.host + window.location.pathname + queryString);


            /*const url = new URL(window.location.href);

            // Read the scroll target before modifying the URL.
            const scrollTargetId = url.searchParams.get('scroll');

            // Remove only the parameters that should not remain in the URL.
            url.searchParams.delete('plugins');
            url.searchParams.delete('skus');

            // Use a relative URL so the current origin is preserved automatically.
            // The existing hash/anchor is also preserved.
            const cleanUrl = `${ url.pathname }${ url.search }${ url.hash }`;

            window.history.replaceState(
                window.history.state,
                '',
                cleanUrl
            );

            if (!scrollTargetId) return;

            const scrollTarget = document.getElementById(scrollTargetId);

            if (scrollTarget) {
                scrollTarget.scrollIntoView();
            }*/
        }

        //----logic to top banner that is created from querystring param: skus OR plugins----
        // queryString :?skus=75 --> top banner :"AudioTrack is available in both Waves Essential and Waves Ultimate"
        // queryString :?skus=75_819_--> top banner :"The plugins you want to access are available in Waves Ultimate"
        // queryString :?plugins=ORVS_ --> top banner :"OVox Vocal ReSynthesis is available in Waves Ultimate"
        // queryString :?plugins=STAS_ORVS_--> top banner :"The plugins you want to access are available in Waves Ultimate"
        //more info: https://wavesaudio.atlassian.net/browse/DSWEB-2666

        let alertSentence = "";
        if(QueryStringsReponse.productName !== null && QueryStringsReponse.productName.length > 0){
            alertSentence = QueryStringsReponse.productName + " is available in";
        }else{
            alertSentence = "The plugins you want to access are available in"
        }

        if(QueryStringsReponse.sbsIncludedIn === 1){

            let tierName = SbsActiveTiers.filter(activeTier => activeTier.itemOrder === 1)[0].tierName;
            setSbsAlertValue(alertSentence + " Waves " + tierName);

        }else if(QueryStringsReponse.sbsIncludedIn === 2){

            let tierName1 = SbsActiveTiers.filter(activeTier => activeTier.itemOrder === 1)[0].tierName;
            let tierName2 = SbsActiveTiers.filter(activeTier => activeTier.itemOrder === 2)[0].tierName;
            setSbsAlertValue(alertSentence + " both Waves " + tierName2 + " & " + tierName1);
        }

    }, [SbsActiveTiers ,QueryStringsReponse]);



    return (
        <div className={`w-full mx-auto relative bg-dark-blue subscription-top-banner`}>


            {sbsAlertValue.length > 0 &&
                <div className="w-full text-white top-banner-bg flex items-center justify-center z-10">

                    {(QueryStringsReponse.productName === null
                        || QueryStringsReponse.productName.length === 0)
                        &&  <div className="px-4 lg:pl-0 py-5 md:py-8"><SbsCheckIcon width={"30px"}/></div>}

                    {(QueryStringsReponse.productName !== null
                        && QueryStringsReponse.productName.length > 0)
                        &&
                        <span className="px-3 md:px-0"><img className="py-2 mr-4" src={ImageCDNDomain + QueryStringsReponse.thumb + "?w=100"} alt={"image for" + QueryStringsReponse.productName}/></span>}

                    <div className="text-sm md:text-xl pr-10">
                        {sbsAlertValue}
                    </div>
                    <button type="button" className="absolute right-0 p-6 cursor-pointer" onClick={() => setSbsAlertValue("")}><CloseIcon
                        width="14px" color="white"/></button>
                </div>
            }

            {
                !IsPriceDifferent  && <MainBannerWCATopNew />
            }

            {
                IsPriceDifferent && <MainBannerPriceDifferent />
            }

            {/* Mobile border */}
            {/*
            <div className="block md:hidden mx-5 pt-12" style={{borderBottom:"1px solid #38424E"}}></div>
*/}

            <PlansPricingDesignNew setShowPluginsPopup={setShowPluginsPopup}/>
            {showPluginsPopup && <PluginsPopup close={() => setShowPluginsPopup(false)}/>}


            {
                IsTwoMonthFreePopupShown && <TwoMonthFreePopup/>
            }


            <SubscriptionSlider />
        </div>

    );
};

export default App;

